import adminApiClient, { tokenStorage } from '../api/adminApiClient'
import type { AdminAuthResponse, AdminLoginRequest, AdminMe } from '../types'

export async function login(credentials: AdminLoginRequest): Promise<AdminAuthResponse> {
  const { data } = await adminApiClient.post<AdminAuthResponse>('/auth/login', credentials)
  tokenStorage.set(data.accessToken, data.refreshToken)
  console.log(`[INFO] Admin login successful — userId: ${data.userId}`)
  return data
}

export async function logout(): Promise<void> {
  try {
    await adminApiClient.post('/auth/logout')
    console.log('[INFO] Admin logout successful')
  } catch (err) {
    console.error('[ERROR] Admin logout failed', err)
  } finally {
    tokenStorage.clear()
  }
}

export async function getMe(): Promise<AdminMe> {
  const { data } = await adminApiClient.get<AdminMe>('/auth/me')
  return data
}

export async function refreshToken(token: string): Promise<AdminAuthResponse> {
  const { data } = await adminApiClient.post<AdminAuthResponse>('/auth/refresh', null, {
    params: { refreshToken: token },
  })
  tokenStorage.set(data.accessToken, data.refreshToken)
  return data
}
